import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Product } from '@vestiaire/api-sdk-angular';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { LikeSuccess } from '@app/+product/store/actions/product.action';

@Component({
  selector: 'vc-product-image-actions-bar',
  templateUrl: './product-image-actions-bar.component.html',
  styleUrls: ['./product-image-actions-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductImageActionsBarComponent implements OnInit {
  public shareTooltipIsOpen = false;

  @Input()
  product: Product;
  @Input()
  isLiked = false;
  @Output()
  scrollTo = new EventEmitter<string>();

  constructor(private store$: Store<IAppState>) {}

  ngOnInit() {}

  likeSuccess(value: Boolean) {
    if (value === true) {
      this.store$.dispatch(new LikeSuccess(this.product));
    }
  }

  toggleShareTooltip() {
    this.shareTooltipIsOpen = !this.shareTooltipIsOpen;
  }

  closeShareTooltip() {
    // give time to click on share link before closing tooltip
    setTimeout(() => {
      this.shareTooltipIsOpen = false;
    }, 100);
  }
}
